import { useQuery } from 'react-query';

import { baseApiUrl, fetcher, ServerErrorResponse } from 'data_sources/constants';

import type { AccreditationBody } from '../../_types/awb';

export default function useAccreditingBody(id?: string, options = {}, onError?: (errors: ServerErrorResponse) => void) {
  const url = `${baseApiUrl()}/awb/accreditation-body/v1/accreditation-bodies/${id}`;
  return useQuery<AccreditationBody, Error>(
    ['accrediting_body', id],
    async () => {
      const data = await fetcher({
        method: 'get',
        url,
      });
      return data;
    },
    {
      ...options,
      enabled: !!id,
    }
  );
}
